module.exports = __webpack_public_path__ + "static/campaign-icon-a464cc703febe0bb2233689df183f819.png";